import React, { useEffect, useState } from "react";
import { Building2, Users, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

// Property Manager portfolio analytics. Full rollups are populated in Phase 10B;
// this section renders portfolio + team entry points and a property count.
export const PortfolioSection = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/properties").then((r) => { if (active) setCount((r.data || []).length); }).catch(() => setCount(0));
    return () => { active = false; };
  }, []);

  return (
    <div className="space-y-3" data-testid="pm-portfolio-section">
      <h3 className="font-display text-base font-semibold">Portfolio &amp; team</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border bg-card p-5">
          <div className="flex items-center gap-2">
            <Building2 className="h-4 w-4 text-primary" />
            <h4 className="font-display text-sm font-semibold">Properties monitored</h4>
          </div>
          <p className="mt-2 font-display text-2xl font-semibold tabular-nums">
            {count === null ? <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /> : count}
          </p>
          <Link to="/app/portfolio"><Button variant="outline" size="sm" className="mt-3" data-testid="pm-view-portfolio">View portfolio analytics</Button></Link>
        </div>
        <div className="rounded-xl border bg-card p-5">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-primary" />
            <h4 className="font-display text-sm font-semibold">Team access</h4>
          </div>
          <p className="mt-2 text-sm text-muted-foreground">Invite team members and manage roles across your portfolio.</p>
          <Link to="/app/team"><Button variant="outline" size="sm" className="mt-3" data-testid="pm-manage-team">Manage team</Button></Link>
        </div>
      </div>
    </div>
  );
};
